import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { BookOpen, X } from "lucide-react";

const KEY = "sempresera-transparency-note";

export const ServicePopup = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem(KEY)) {
      const t = setTimeout(() => setVisible(true), 2500);
      return () => clearTimeout(t);
    }
  }, []);

  const dismiss = () => {
    localStorage.setItem(KEY, "acknowledged");
    setVisible(false);
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ y: 40, opacity: 0, scale: 0.97 }}
          animate={{ y: 0, opacity: 1, scale: 1 }}
          exit={{ y: 40, opacity: 0, scale: 0.97 }}
          transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
          className="fixed bottom-4 right-4 z-50 max-w-sm"
          data-testid="service-transparency-popup"
          role="dialog"
          aria-label="Transparency note"
        >
          <div className="glass relative p-6">
            <button
              type="button"
              onClick={dismiss}
              className="absolute right-3 top-3 text-[#A8B4C2] transition-colors duration-200 hover:text-white"
              data-testid="service-popup-close"
              aria-label="Dismiss"
            >
              <X size={16} />
            </button>
            <div className="flex items-center gap-2.5">
              <BookOpen size={18} className="shrink-0 text-brand" />
              <p className="font-display text-sm font-bold uppercase tracking-[0.2em] text-brand">
                Fully transparent, always
              </p>
            </div>
            <p className="mt-3 text-sm leading-relaxed text-[#C9D2DE]">
              We want customers who understand exactly what they're buying. Every technical term on this page is
              decoded in plain English in our{" "}
              <Link to="/glossary" onClick={dismiss} className="text-brand hover:underline" data-testid="service-popup-glossary-link">
                IT Glossary
              </Link>
              — because informed customers make the best clients.
            </p>
            <button
              type="button"
              onClick={dismiss}
              className="mt-4 w-full border border-white/15 py-2 font-display text-xs font-bold uppercase tracking-[0.2em] text-zinc-300 transition-colors duration-300 hover:border-brand hover:text-brand"
              data-testid="service-popup-dismiss"
            >
              Got it
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
